<template>
  <div id="finish">
      <div>
        <div class="icon"><img src="@/assets/image/rateLev_3.svg"></div>
    
    <p>{{lang.msg_err_url}}</p>
    <h4>{{lang.try_again}}</h4>
      </div>
  
<Footer/>
  </div>
</template>


<script>
import Footer from '@/components/layout/Footer'
export default {
    name: 'Finish',
    components: {
      Footer
    },
    props: ['lang']
}
</script>

<style lang="scss" scoped>
  #finish{
    // @include flexs(center, center, column);
    
    

    >div{
      @include flexs(center, center, column);
      text-align: center;
      min-height: calc(100vh - 96px);
     *{
        margin-bottom: 16px;
        word-break: keep-all;
      }

      .icon{
        @include size(56px, 56px);
        background-color: $color-point;
        border-radius: 100%;
        position: relative;
        margin-bottom: 24px;
        
          img{
            filter: brightness(0) invert(1);
            @include transform;
            width: 40px;
          }
      }

      h4{
        color: $color-point;
      }

      small{
        margin: 1rem 2rem;
        color: $color-border;
      }
      }
     
 

    

  }
  
</style>